import { render } from "./ContactCurrentGroupHeader.vue?vue&type=template&id=a5c79b3e"
import script from "./ContactCurrentGroupHeader.vue?vue&type=script&lang=js"
export * from "./ContactCurrentGroupHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__